import { Flex, Typography } from '@banhala/ui-kit';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { isNotNil } from 'shared/src/utils';
import { getDayOfWeek } from 'shared/src/utils/date-utils';
import { isNil } from 'shared/src/utils/isNil';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { useDeliveryInfoMessage } from '../hooks/useDeliveryInfoMessage';
import { DeliveryBadgeRow } from './DeliveryBadgeRow';
import { TitleContent } from './TitleContent';
import 'dayjs/locale/ko';

export const PreOrderDeliverySection = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const deliveryInfoMessage = useDeliveryInfoMessage();

  const orderPeriodText = useMemo(() => {
    const startDate = goodsBasic?.sales_method_info?.order_start_date;
    const endDate = goodsBasic?.sales_method_info?.order_end_date;

    if (isNil(startDate) || isNil(endDate)) return null;

    const startDay = dayjs(startDate).locale('ko');

    const startText = `${startDay.format('M/D')}(${getDayOfWeek(startDate)}) ${startDay.format('A h')}시`;
    const endText = `${dayjs(endDate).format('M/D')}(${getDayOfWeek(endDate)})`;

    return `${startText} ~ ${endText}`;
  }, [
    goodsBasic?.sales_method_info?.order_start_date,
    goodsBasic?.sales_method_info?.order_end_date,
  ]);

  return (
    <>
      <TitleContent title={'배송정보'}>
        <Flex gap={4}>
          <Flex.Row gap={8} alignItems={'center'}>
            <DeliveryBadgeRow testID={'프리오더툴팁'} />
          </Flex.Row>
        </Flex>
      </TitleContent>
      <TitleContent title={''}>
        <Typography type={'body2'}>{deliveryInfoMessage}</Typography>
      </TitleContent>
      {isNotNil(orderPeriodText) && (
        <Flex margin={{ top: 12 }}>
          <TitleContent title={'판매기간'}>
            <Typography type={'body2'}>{orderPeriodText}</Typography>
          </TitleContent>
        </Flex>
      )}
    </>
  );
};
